export enum RadabankOverdraftStep {
	Initial,
	General,
	PropertyStatus,
	SocialStatus,
	LastQuestions,
}
